import React, { useRef } from "react";
import InputBoxes from "../common/InputBoxes";
import { checkChildrenAndSetFocus, NO_OF_BANK_ACCOUNT_HOLDER_COLUMN, NO_OF_BANK_ACCOUNT_NO_COLUMN, NO_OF_BANK_BRANCH_COLUMN, NO_OF_BANK_COLUMN, NO_OF_BANK_SUFFIX_COLUMN } from "../common/interactiveCommon";
const KS10BankDetail = (props) => {
  const { bank, bankBranch, bankAccountNumber, bankSuffix, bankAccountHolder, setBankData } = props;
  const bankDivRef = useRef(null);
  const bankBranchDivRef = useRef(null);
  const bankAccountNumberDivRef = useRef(null);
  const bankSuffixDivRef = useRef(null);
  const bankAccountHolderDivRef = useRef(null);

  const onTextChange = (e) => {
    const { name, value } = e.target;
    const index = name.replace("bank", "").replace("Branch", "").replace("AccountNumber", "").replace("Suffix", "").replace("AccountHolder", "");
    
    if (name.indexOf("bankBranch") >= 0) {
      checkChildrenAndSetFocus(bankBranchDivRef.current.children, index);
    } else if (name.indexOf("bankAccountNumber") >= 0) {
      checkChildrenAndSetFocus(bankAccountNumberDivRef.current.children, index);
    } else if (name.indexOf("bankSuffix") >= 0) {
      checkChildrenAndSetFocus(bankSuffixDivRef.current.children, index);
    } else if (name.indexOf("bankAccountHolder") >= 0) {
      checkChildrenAndSetFocus(bankAccountHolderDivRef.current.children, index);
    } else if (name.indexOf("bank") >= 0) {
      checkChildrenAndSetFocus(bankDivRef.current.children, index);
    }
    setBankData({ name, value });
  };
  return (
    <div className="row">
      <div className="mb-3 section-number-box col-sm-12 col-md-12 col-lg-12">
        <div className="mb-3 number">6.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label">
              <label className="">Bank account details</label>
            </div>
            <div className="section-form-group">
              <div className="section-form-group-inline pr-2" ref={bankDivRef}>
                <InputBoxes keyName={"bank"} name={bank} count={NO_OF_BANK_COLUMN} onTextChange={onTextChange} />
                <small className="small-title-label d-flex justify-content-center">Bank</small>
              </div>

              <div className="section-form-group-inline pr-2" ref={bankBranchDivRef}>
              <InputBoxes keyName={"bankBranch"} name={bankBranch} count={NO_OF_BANK_BRANCH_COLUMN} onTextChange={onTextChange} />
                <small className="small-title-label d-flex justify-content-center">Branch</small>
              </div>

              <div className="section-form-group-inline pr-2" ref={bankAccountNumberDivRef}>
                <InputBoxes keyName={"bankAccountNumber"} name={bankAccountNumber} count={NO_OF_BANK_ACCOUNT_NO_COLUMN} onTextChange={onTextChange} />
                <small className="small-title-label d-flex justify-content-center">Account number</small>
              </div>
              <div className="section-form-group-inline" ref={bankSuffixDivRef}>
              <InputBoxes keyName={"bankSuffix"} name={bankSuffix} count={NO_OF_BANK_SUFFIX_COLUMN} onTextChange={onTextChange} />
                <small className="small-title-label d-flex justify-content-center">Suffix</small>
              </div>
              <div className="section-form-group-inline" ref={bankAccountHolderDivRef}>
              <InputBoxes keyName={"bankAccountHolder"} name={bankAccountHolder} count={NO_OF_BANK_ACCOUNT_HOLDER_COLUMN} onTextChange={onTextChange} set20PXWidth={true}  />
                <small className="small-title-label d-flex small-label">Name of account holder</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10BankDetail;
